import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface BlogArticle {
  id: string;
  title: string;
  description: string | null;
  image_url: string | null;
  article_url: string;
  published_at: string | null;
}

export const useBlogArticles = (limit = 6) => {
  return useQuery({
    queryKey: ["blog-articles", limit],
    queryFn: async (): Promise<BlogArticle[]> => {
      const { data, error } = await supabase
        .from("blog_articles")
        .select("id, title, description, image_url, article_url, published_at")
        .order("published_at", { ascending: false })
        .limit(limit);

      if (error) {
        console.error("Error fetching blog articles:", error);
        throw error;
      }

      return data || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
